import { useMemo } from "react";

import { useSelector } from "react-redux";

import useBaseSettingsQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useBaseSettingsQuery";
import { filterProfilesForCompanyAnalysis } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/helpers/accessLevelFilters";
import { selectProfilesList } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/store/selectors";

export default function useProfilesByAccTechSubCategory() {
    const profiles = useSelector(selectProfilesList);
    const { data } = useBaseSettingsQuery();
    const accTechSubCategory = data?.accountTechSubCategory;
    const isShippingAccount =
        typeof accTechSubCategory !== "undefined" && accTechSubCategory.match(/shipping/gi) !== null;

    return useMemo(() => filterProfilesForCompanyAnalysis(profiles, isShippingAccount), [profiles, isShippingAccount]);
}
